// Client-side "seen/dismissed" state for the engagement-move announcements.
//
// Each feature persists independently in browser localStorage under a distinct
// global (non-user-namespaced) key, following the existing
// `nonDuesRevenueAnnouncementDismissed` precedent. Persistence is per
// browser/device and is not synchronized server-side. The homepage message is
// intentionally excluded — it is managed by the NoteRouter Alerts feature and
// has no localStorage flag.

export const ENGAGEMENT_MOVED_MANAGE_BANNER_DISMISSED =
  'engagementMovedManageBannerDismissed';
export const ENGAGEMENT_MOVED_DRAWER_GLOW_SEEN =
  'engagementMovedDrawerGlowSeen';

export const isEngagementFlagSet = key => localStorage.getItem(key) === 'true';

export const setEngagementFlag = key => localStorage.setItem(key, 'true');
